import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_close",
  "use": "icon-ic_close-usage",
  "viewBox": "0 0 31 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 31\" id=\"icon-ic_close\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-6-6h44v44H-6z\" /><path d=\"m2 2 27.505 27.505M2 29.505 29.505 2\" opacity=\".6\" stroke=\"#FFF\" stroke-width=\"4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol